import { makeStyles } from '@mui/styles';

import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ palette }) => ({
    root: {
      color: palette.brand.main,
    },
  })
);

const MoreIconButton = ({ ariaLabel, ...otherProps }) => {
  const classes = useStyles();
  return (
    <IconButton
      classes={{ root: classes.root }}
      size="large"
      aria-label={ariaLabel}
      {...otherProps}
    >
      <MoreVertIcon />
    </IconButton>
  );
};

export default MoreIconButton;
